import { useCallback, useEffect, useRef, useState } from 'react';
import {
  getDraftAttachment,
  getDraftAttachmentKey,
  getDraftMessage,
  getDraftMessageKey
} from 'features/message-center/utils';

export const useDraftTextMessage = ({ id, onChangeMessage }) => {
  const debounceRef = useRef(null);
  const [draft, setDraft] = useState('');

  useEffect(() => {
    if (!id) return;

    const draftMessage = getDraftMessage(id);
    const draftAttachment = getDraftAttachment(id);
    setDraft(draftMessage);
    onChangeMessage && onChangeMessage(draftMessage, draftAttachment);
  }, [id, onChangeMessage]);

  const saveDraftMessage = useCallback(
    message => {
      if (!id) return;

      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        if (message) {
          localStorage.setItem(getDraftMessageKey(id), message);
          setDraft(message);
        } else {
          localStorage.removeItem(getDraftMessageKey(id));
          setDraft('');
        }
      }, 500);
    },
    [id]
  );

  const saveDraftAttachment = attachment => {
    if (!id) return;
    localStorage.setItem(getDraftAttachmentKey(id), JSON.stringify(attachment));
  };
  const removeDraftAttachment = () => {
    if (!id) return;
    localStorage.removeItem(getDraftAttachmentKey(id));
  };

  const removeDraftMessage = useCallback(() => {
    if (!id) return;

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    localStorage.removeItem(getDraftMessageKey(id));
    setDraft('');
  }, [id]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  return {
    draft,
    removeDraftAttachment,
    removeDraftMessage,
    saveDraftAttachment,
    saveDraftMessage
  };
};
